module.exports = __webpack_public_path__ + "static/media/generic-user.bf5b906e.png";